import React from 'react';
import { action } from 'mobx';
import { LocalStorage } from '@vromo/models';

import Switch from '@vromo/ui/components/Switch';

import { useStore } from '@vromo/mobx-react';
import { observer } from 'mobx-react-lite';
import FontAwesome from '@vromo/ui/components/FontAwesome';

export default observer(function DarkMode() {
    const rootStore = useStore('rootStore');

    return (
        <div
            onClick={(e) => e.preventDefault()}
            style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: 10
            }}>
            <FontAwesome icon="sun" large style={{ margin: 4 }} />
            <Switch
                color="#263C61"
                checked={rootStore.viewStore.darkMode}
                onChange={action((checked) => {
                    rootStore.viewStore.darkMode = checked;
                    LocalStorage.darkMode = checked;
                })}
                style={{ margin: 4 }}
            />
            <FontAwesome icon="moon" large style={{ margin: 4 }} />
        </div>
    );
});
